import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Location } from '@r1-frontend/ui-react/components/svg/location';

import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { getCurrentCity } from '~/src/store/selectors/city';

import * as ST from './styled';

interface IProps {
    className?: string,
}

export const CitySelect = ({ className }: IProps) => {
    const dispatch = useDispatch();
    const city = useSelector(getCurrentCity);
    const openCitySelectHandler = () => dispatch(openCitySelect());

    return <ST.CityWrapper
        role='button'
        onClick={openCitySelectHandler}
        data-test='city-select-btn'
        className={className}
    >
        <Location size={14}/>
        <span>{city ? city.name : null}</span>
    </ST.CityWrapper>;
};
